<app-table [columns]="columns" [data]="companies" [settings]="settings" [loading]="loading">
    <ng-template #field let-item="item">
        <a href="/sites/{{item.id}}" (click)="$event.preventDefault(); navigateToSite(item.id)">{{ item.name }}</a>
    </ng-template>
</app-table>